module.exports = __webpack_public_path__ + "img/mineria3d.256a2b0f.jpg";